import AnalyticsTracking from "@helpers/analyticsTracking";
import {
  createElement,
  getItemLocalStorage,
  select,
  selectAll,
  setItemLocalStorage,
} from "@utils/function";

/**
 * Create player locator
 */
export default function CreatePlayerOnRangeTennis(config) {
  const playerLocation = select(".player-locator-content .slider-content");
  playerLocation.textContent = "";

  // add search input player
  playerLocation.insertAdjacentHTML("beforeend", searchPlayer());

  // add player row information (playing, practicing, favorite)
  playerLocation.insertAdjacentHTML("beforeend", playerRowInformation());

  // --------------------------
  // create player row
  createPlayersRowTennis(config);

  // --------------------------
  // search plauer
  searchPlayerRowTennis();
}

function createPlayersRowTennis(config) {
  let players = HQ.Properties.players;

  const playerLocation = select(".player-locator-content .slider-content");

  const favoritePlayers = getItemLocalStorage("HQfavoritePlayers");

  if (!favoritePlayers) {
    setItemLocalStorage("HQfavoritePlayers", []);
  }

  players = favoritePlayers
    ? checkIfFavoritePlayers(players, favoritePlayers, config)
    : players;

  const containerWrapper = createElement("div");
  containerWrapper.classList.add("container-locator-wrapper");

  playerLocation.appendChild(containerWrapper);

  Object.entries(players).forEach(([key, value]) => {
    let {
      id,
      description,
      PlayerId,
      PlayerFirstName,
      PlayerLastName,
      PlayerNatlId,
      isOnRangeArea,
      isPlaying,
      isGpsTracked,
      clone,
      isFavorite,
      image,
      place_id,
    } = value;

    const iconPLayerSVG = `
      <span class="player-icon">
        <svg fill="#3e3e3e">
          <use href="#icon-tennis-playing"></use>
        </svg>
      </span>
    `;

    const iconIsOnRange = `
      <span class="driving-range">
        <svg fill="#3e3e3e">
          <use href="#icon-driving-range"></use>
        </svg>
      </span>
    `;

    image = image
      ? `<img loading="lazy" src="${image}" height="50">`
      : '<svg fill="#efefef"><use href="#icon-placeholder-man"></use></svg >';

    const cursorPointer =
      isPlaying || isOnRangeArea || (isGpsTracked && place_id !== null)
        ? " cursor-pointer"
        : "";

    const dataFullName = `data-full-name="${PlayerFirstName} ${PlayerLastName}"`;

    const playerInfo = `${PlayerFirstName} ${PlayerLastName} ${
      description ?? ""
    }`;

    // const dataId =
    //   place_id !== null ? `data-id=${place_id}` : `data-id=${PlayerId}`;
    const dataId = `data-id=${PlayerId}`;

    const svgIsPlaying = isPlaying ? iconPLayerSVG : "";
    const svgIsOnRangeArea = isOnRangeArea ? iconIsOnRange : "";

    const captain = isGpsTracked ? 'data-captain="true"' : "";

    const isFavoritePlayer = isFavorite ? 'data-favorite-player="true"' : "";

    const isClone = clone ? 'data-favorite-player-clone="true"' : "";

    const dataPlaceId = place_id ? `data-place-id=${place_id}` : "";

    const openCourt = isPlaying ? " open-court" : "";

    const rowTemplate = `
      <div class="container">
          <div class="player-row player-row-golf row p-2${openCourt}${cursorPointer}" ${dataFullName} ${dataId} ${dataPlaceId} ${captain} ${isFavoritePlayer} ${isClone}>
          <div class="col-1 d-flex align-items-center p-0">
            <span title="${PlayerNatlId}" class="flag-icon flag-icon-match flag-icon-${PlayerNatlId?.toLowerCase()}"></span>
          </div>
          <div class="col-2 d-flex align-items-center justify-content-center mach-player-image">${image}</div>
          <div class="col-6 d-flex align-items-center player-name">${playerInfo}</div>
          <div class="col-2 d-flex justify-content-center align-items-center mach-player-icon p-0">${svgIsPlaying}${svgIsOnRangeArea}</div>
          <div class="p-1 col-1 text-center d-flex align-items-center prevent-close">
            <div class="icon-star-tennis">
              <svg><use href="#icon-star"></use></svg>
            </div>
          </div>
        </div>
      </div>
    `;

    return containerWrapper.insertAdjacentHTML("beforeend", rowTemplate);
  });
}

function checkIfFavoritePlayers(players, favoritePlayers, config) {
  if (!favoritePlayers) return;

  favoritePlayers.map((favoritePlayerID) => {
    const player = players.find(
      (player) => player.PlayerId === favoritePlayerID
    );

    if (player && !player.isFavorite && !player.clone) {
      player.isFavorite = true;

      // clone player
      const clonePlayer = { ...player };
      clonePlayer.clone = true;

      players.unshift(clonePlayer);
    }
  });

  const { dataID, fullName, isFavoritePlayer } = config || {};

  // check if config is exist
  if (config) {
    const player = players.find((player) => player.PlayerId === dataID);
    const favPlayer = favoritePlayers.find((player) => player === dataID);

    // remove player
    if (dataID === favPlayer && isFavoritePlayer) {
      // console.log("remove player");

      // remove playerId from favoritePlayers localStorage
      // update localStorage

      favoritePlayers.splice(favoritePlayers.indexOf(player.PlayerId), 1);
      setItemLocalStorage("HQfavoritePlayers", favoritePlayers);

      // remove object from players where PlayerId and clone is true
      const index = players.findIndex(
        (player) => player.PlayerId === dataID && player.clone === true
      );

      // remove object from players (all players)
      players.splice(index, 1);

      // find playerId in players and remove isFavorite property
      const indexPlayer = players.findIndex(
        (player) => player.PlayerId === dataID
      );

      // set isFavorite to false
      players[indexPlayer].isFavorite = false;
    }

    // add player
    // if player not exist in favoritePlayers localStorage
    if (!isFavoritePlayer && !favPlayer) {
      // console.log("add player");

      // add player dataID to favoritePlayers localStorage
      favoritePlayers.push(dataID);
      setItemLocalStorage("HQfavoritePlayers", favoritePlayers);

      // set isFavorite to true
      player.isFavorite = true;

      // clone player
      const clonePlayer = { ...player };
      clonePlayer.clone = true;

      // add clone player to players object (all players)
      players.unshift(clonePlayer);

      AnalyticsTracking("setFavorite", { name: fullName });
    }
  }

  return players;
}

/**
 * Search player row
 */
function searchPlayerRowTennis() {
  const searchPlayer = select("#search-player");

  searchPlayer.addEventListener("input", (e) => {
    const target = e.target;
    const lengthString = target.value.length;

    if (lengthString > 0) {
      // if length string > 0, show button clear
      // and trid to find player
      showHideButtonClear(true);
      findPlayer(target.value);
    } else {
      // if length string = 0,
      // clear result and remove text in input
      clearList(searchPlayer);
      showHideButtonClear(false);
    }
  });
}

/**
 * Clear result and remove text in input
 *
 * @param {HTMLInputElement} searchInput
 */
function clearResultAndRemoveTextInInput(searchInput) {
  clearList(searchInput);
  showHideButtonClear(false);
}

/**
 * Clear list, remove hidden class
 *
 * @param {HTMLInputElement} searchInput
 */
function clearList(searchInput) {
  searchInput.value = "";

  const allRows = selectAll(".player-row");
  allRows.forEach((row) => {
    row.classList.remove("hidden");
  });
}

/**
 * Show or hide button clear
 *
 * @param {boolean} show
 */
function showHideButtonClear(show) {
  const clearSearchLocator = select(".clear-search-locator");
  clearSearchLocator.classList[show ? "remove" : "add"]("hidden");
}

/**
 * Find player
 *
 * @param {string} player
 */
function findPlayer(player) {
  const allRows = selectAll(".player-locator-content .player-row");

  allRows.forEach((row) => {
    // get full name from data attribute
    const fullName = row.dataset.fullName;

    // if full name includes player, remove hidden class
    if (fullName.toLowerCase().includes(player.toLowerCase())) {
      row.classList.remove("hidden");
    } else {
      row.classList.add("hidden");
    }
  });
}

/**
 * Player row information
 */
function playerRowInformation() {
  return `
    <div class="container player-row-information">
      <div class="row align-items-baseline">
        <div class="col-auto pe-0">
            <div class="player-col text-nowrap">
              Select to find player:
            </div>
        </div>
        <div class="col-auto me-auto p-0">
          <div class="second-section d-flex">
              <div class="player-col p-playing">
                <span class="player-icon">
                  <svg fill="#3e3e3e"><use href="#icon-tennis-playing"></use></svg>
                </span>
                <span class="info-text">Playing</span>
              </div>
              <div class="player-col p-practicing">
                <span class="driving-range">
                  <svg fill="#3e3e3e"><use href="#icon-tennis-racket"></use></svg>
                </span>
                <span class="info-text">Practicing</span>
              </div>
            </div>
        </div>
        <div class="col-auto ps-0"><div class="last-section">Fav</div></div>
      </div>
    </div>
  `;
}

/**
 * Search input player locator
 */
function searchPlayer() {
  return `
    <div class="search-player">
      <div class="d-flex align-items-center">
        <input type="text" id="search-player" autocomplete="off" placeholder="Search player" class="form-control" aria-expanded="false">
      </div>
      <button class="clear-search-locator hidden" aria-label="Clear search"></button>
    </div>
  `;
}

// -------------------------------------------------------
// Event

document.addEventListener("click", (e) => {
  e.stopPropagation();

  const searchPlayer = select("#search-player");

  const target = e.target;

  if (target.closest(".clear-search-locator")) {
    clearResultAndRemoveTextInInput(searchPlayer);
  }
});
